// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rx-card {
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
  overflow: hidden;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.rx-card:hover {
  border-color: #CBD5E1;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);
}

.rx-card__accent {
  height: 4px;
  width: 100%;
  background: #0EA5E9;
}

.rx-card__inner {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rx-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #F1F5F9;
}

.rx-card__identity {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.rx-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #BAE6FD;
  background: #F0F9FF;
  color: #0284C7;
  flex-shrink: 0;
  font-size: 16px;
  margin-top: 1px;
}

.rx-card__heading {
  min-width: 0;
}

.rx-card__title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.rx-card__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.25;
}

.rx-card__status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 18px;
  padding: 0 7px;
  border-radius: 9999px;
  border: 1px solid #A7F3D0;
  background: #ECFDF5;
  color: #059669;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.rx-card__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: #10B981;
}

.rx-card__meta {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.35;
  font-variant-numeric: tabular-nums;
}

.rx-card__print {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94A3B8;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.12s ease, color 0.12s ease;
}

.rx-card__print:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.rx-card__prescriber {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  font-size: 12px;
  color: #475569;
  line-height: 1.35;
}

.rx-card__prescriber-main {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.rx-card__prescriber-icon {
  color: #0284C7;
  font-size: 14px;
  flex-shrink: 0;
}

.rx-card__prescriber strong {
  color: #0F172A;
  font-weight: 600;
}

.rx-card__meds {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rx-card__med {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
}

.rx-card__med-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.rx-card__med-name {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.3;
}

.rx-card__med-form {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 4px;
  background: #E2E8F0;
  color: #475569;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.rx-card__med-desc {
  margin: 6px 0 0;
  font-size: 12px;
  color: #334155;
  line-height: 1.45;
}

/* Clip the print tree on screen. The ref'd .rx-print-root is cloned without this host. */
.rx-print-host {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.rx-print-root {
  width: 210mm;
  background: #fff;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/components/Prescription/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,yFAAyF;AACzF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".rx-card {\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n  overflow: hidden;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.rx-card:hover {\n  border-color: #CBD5E1;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.06);\n}\n\n.rx-card__accent {\n  height: 4px;\n  width: 100%;\n  background: #0EA5E9;\n}\n\n.rx-card__inner {\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rx-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.rx-card__identity {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n\n.rx-card__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #BAE6FD;\n  background: #F0F9FF;\n  color: #0284C7;\n  flex-shrink: 0;\n  font-size: 16px;\n  margin-top: 1px;\n}\n\n.rx-card__heading {\n  min-width: 0;\n}\n\n.rx-card__title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.rx-card__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.25;\n}\n\n.rx-card__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 18px;\n  padding: 0 7px;\n  border-radius: 9999px;\n  border: 1px solid #A7F3D0;\n  background: #ECFDF5;\n  color: #059669;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.rx-card__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: #10B981;\n}\n\n.rx-card__meta {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.35;\n  font-variant-numeric: tabular-nums;\n}\n\n.rx-card__print {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #94A3B8;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.rx-card__print:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.rx-card__prescriber {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  font-size: 12px;\n  color: #475569;\n  line-height: 1.35;\n}\n\n.rx-card__prescriber-main {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.rx-card__prescriber-icon {\n  color: #0284C7;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.rx-card__prescriber strong {\n  color: #0F172A;\n  font-weight: 600;\n}\n\n.rx-card__meds {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rx-card__med {\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n}\n\n.rx-card__med-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.rx-card__med-name {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.rx-card__med-form {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 4px;\n  background: #E2E8F0;\n  color: #475569;\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.rx-card__med-desc {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: #334155;\n  line-height: 1.45;\n}\n\n/* Clip the print tree on screen. The ref'd .rx-print-root is cloned without this host. */\n.rx-print-host {\n  position: absolute;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.rx-print-root {\n  width: 210mm;\n  background: #fff;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
